export default "__VITE_ASSET__5GgW_oyz__"